export type AiScope = 'selection' | 'full';

/**
 * Determina l'ambito di refining AI in base al testo selezionato nell'editor.
 * Se c'è testo selezionato (non solo spazi) agisce sulla selezione, altrimenti su tutto l'articolo.
 */
export function determineAiScope(selectedText: string): AiScope {
  return selectedText.trim().length > 0 ? 'selection' : 'full';
}

/** Limite caratteri del contenuto inviato al refining AI.
 *  DEVE restare allineato a REFINE_MAX_CONTENT in backend/services/aiService.js. */
export const AI_REFINE_MAX_CONTENT = 15000;

/** Limite caratteri quando il RichEditor riceve una funzione `aiRefine` propria (verbali):
 *  allineato al massimo di `html` accettato da POST /api/representative/events/:id/verbale/riscrivi. */
export const AI_REFINE_COLLEGATO_MAX_CONTENT = 60000;
